module.exports = __webpack_public_path__ + "static/media/whale.97ee770c.svg";